import { type ComponentType, type PropsWithChildren, forwardRef, type ElementType } from 'react';

import { stackItemRecipe } from './Stack.css';
import { getClassNames } from '../../util/css';
import { type BooleanVariant } from '../../util/css/vanilla-extract';
import { type RecipeVariants } from '../../vanilla-extract.css';

const sparkyClassName = 'sparky-stack-item';

type StackItemProps = Omit<RecipeVariants<typeof stackItemRecipe>, 'grow' | 'shrink'> & {
  as?: ElementType | ComponentType<Record<string, unknown>>;
  className?: string;
  grow?: BooleanVariant;
  shrink?: BooleanVariant;
};

export const StackItem = forwardRef<HTMLDivElement, PropsWithChildren<StackItemProps>>(
  ({ children, as: Tag = 'div', className = '', grow, shrink = true, ...rest }, ref) => {
    const classNames = getClassNames(
      sparkyClassName,
      stackItemRecipe({
        grow: grow as RecipeVariants<typeof stackItemRecipe>['grow'],
        shrink: shrink as RecipeVariants<typeof stackItemRecipe>['shrink'],
      }),
      className,
    );

    return (
      <Tag ref={ref} className={classNames} {...rest}>
        {children}
      </Tag>
    );
  },
);

StackItem.displayName = 'StackItem';
